// extracted by mini-css-extract-plugin
export var navbar = "Navbar-module--navbar--3hLsb";
export var items = "Navbar-module--items--W3FWB";